import { Trans } from "@lingui/react/macro";
import React, { useMemo } from "react";
import {
  ModalProps,
  BaseModalProps,
  Modal as BaseModal
} from "@silversea-ssc/ui-components-react";

const Modal: React.FC<React.PropsWithChildren<ModalProps>> = ({
  children,
  ...props
}) => {
  const modalPropsWithOverrides = useMemo((): BaseModalProps => {
    return {
      ...props.modal,
      preventScroll: props.modal.isOpen,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      appElement: document.getElementById("___gatsby")!
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(props.modal)]);

  return (
    <BaseModal
      {...props}
      labels={
        props.labels ?? {
          close: <Trans id="Modal close button label">Close</Trans>
        }
      }
      modal={modalPropsWithOverrides}
    >
      {children}
    </BaseModal>
  );
};

export type { BaseModalProps, ModalProps };
export default Modal;
